// extracted by mini-css-extract-plugin
module.exports = {"card":"card--36Dxi","soft_button":"soft_button--3E5-C","soft_button_busing":"soft_button_busing--ziYx-","soft_button_open":"soft_button_open--1q0EV"};